import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginView } from './views/login/login.component';
import { ApiInterceptor } from './services/auth.interceptor';
import { FormReceivedView } from './views/form-received/form-received.component';
import { OAuthModule } from 'angular-oauth2-oidc';
import { VippsComponent } from './views/vipps/vipps.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginView,
    FormReceivedView,
    VippsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    OAuthModule.forRoot(),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
